document.addEventListener("DOMContentLoaded", () => {
  const quantityInput = document.querySelector("[data-grjs-value]");
  const subtotalElement = document.querySelector(".gr-product-form__subtotal");
  const variantRadios = document.querySelectorAll(
    '.gr-product-options__swatches input[type="radio"]',
  );
  const galleryCheckboxes = document.querySelectorAll(
    ".gr-greeting-card-gallery [data-grjs-price]",
  );

  const updateSubtotal = () => {
    const subtotalPriceElement = document.querySelector(
      ".gr-js-subtotal-price",
    );
    const initialPrice = parseFloat(subtotalElement.dataset.grInitialPrice);
    const quantity = parseInt(
      quantityInput.getAttribute("data-grjs-value"),
      10,
    );

    let additionalPrice = 0;
    galleryCheckboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        additionalPrice += parseFloat(checkbox.getAttribute("data-grjs-price"));
      }
    });

    const subtotal = (initialPrice * quantity + additionalPrice) / 100;
    const formattedSubtotal = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(subtotal);

    subtotalPriceElement.textContent = formattedSubtotal;
  };

  updateSubtotal();

  const observer = new MutationObserver(() => {
    updateSubtotal();
  });

  observer.observe(quantityInput, {
    attributes: true,
    attributeFilter: ["data-grjs-value"],
  });

  if (variantRadios.length && subtotalElement) {
    variantRadios.forEach((radio) => {
      radio.addEventListener("change", (event) => {
        const selectedOption = event.target;
        const newPrice = selectedOption.getAttribute("data-grjs-price");

        if (newPrice) {
          subtotalElement.setAttribute("data-gr-initial-price", newPrice);
          updateSubtotal();
        }
      });
    });
  }

  galleryCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", () => {
      updateSubtotal();
    });
  });
});


window.addEventListener("load", () => {
  const galleryNav = document.querySelector(".gr-media-gallery__nav");
  const thumbnailList = document.querySelector(".gr-thumbnail-list");
  const sliderArrows = document.querySelectorAll(".media-gallery__arrow");

  const toggleArrowsVisibility = () => {
    if (!thumbnailList || !sliderArrows) return;

    const containerWidth = thumbnailList.clientWidth;
    const sliderWidth = thumbnailList.scrollWidth;

    if (sliderWidth <= containerWidth) {
      galleryNav.classList.remove("shadows-visible");
      sliderArrows.forEach((arrow) => arrow.classList.add("media-gallery__arrow--hidden"));
    } else {
      galleryNav.classList.add("shadows-visible");
      sliderArrows.forEach((arrow) => arrow.classList.remove("media-gallery__arrow--hidden"));
    }

    galleryNav.style.visibility = "visible";
    sliderArrows.forEach((arrow) => (arrow.style.visibility = "visible"));
  };

  toggleArrowsVisibility();

  window.addEventListener("resize", toggleArrowsVisibility);
});

const observer = new MutationObserver(() => {
  toggleArrowsVisibility();
});

observer.observe(thumbnailList, { childList: true, subtree: true });
